import { Union } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { union_type, lambda_type, array_type, option_type, int32_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { Document$_$reflection, DocumentCategory_$reflection } from "../Shared/ApiDataTypes.js";
import { Tree$2, Tree_append, Tree_map, Tree_update, Tree_filter, Tree$2_$reflection } from "../Shared/Tree.js";
import { createContext } from "../fable_modules/Feliz.2.8.0/Internal.fs.js";
import { append, map, choose } from "../fable_modules/fable-library-js.4.24.0/Array.js";
import React from "react";
import * as react from "react";
import { reactApi } from "../fable_modules/Feliz.2.8.0/Interop.fs.js";

export class Message extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["AddCategory", "RemoveCategory", "SetCategories", "UpdateCategories"];
    }
}

export function Message_$reflection() {
    return union_type("DocumentTreeContexts.Message", [], Message, () => [[["parentTreeId", option_type(int32_type)], ["Item2", DocumentCategory_$reflection()]], [["Item", DocumentCategory_$reflection()]], [["Item", array_type(Tree$2_$reflection(Document$_$reflection(), DocumentCategory_$reflection()))]], [["parentTreeId", int32_type], ["Item2", lambda_type(DocumentCategory_$reflection(), DocumentCategory_$reflection())]]]);
}

export const CategoriesContext = createContext("Categories", []);

export const CategoriesDispatchContext = createContext("CategoriesDispatch", undefined);

export function update(model, msg) {
    switch (msg.tag) {
        case 1:
            return choose((tree_2) => Tree_filter((_arg) => true, (node_1) => (node_1.Id !== msg.fields[0].Id), tree_2), model);
        case 2:
            return msg.fields[0];
        case 3:
            return choose((tree_4) => Tree_update((arg) => Tree_map((x) => x, msg.fields[1], arg), (_arg_1) => false, (node_2) => (node_2.Id === msg.fields[0]), tree_4), model);
        default: {
            const toAdd = msg.fields[1];
            const parentTreeIdOpt = msg.fields[0];
            if (parentTreeIdOpt != null) {
                const parentTreeId = parentTreeIdOpt | 0;
                return map((tree) => Tree_append((node) => (node.Id === parentTreeId), [new Tree$2(1, [toAdd, []])], tree), model);
            }
            else {
                return append(model, [new Tree$2(1, [toAdd, []])]);
            }
        }
    }
}

export function CategoriesProvider(categoriesProviderInputProps) {
    const children = categoriesProviderInputProps.children;
    const patternInput = reactApi.useReducer(update, []);
    let child_1;
    const child = react.createElement(react.Fragment, {}, children);
    child_1 = reactApi.createElement(CategoriesDispatchContext.Provider, {
        value: patternInput[1],
    }, child);
    return reactApi.createElement(CategoriesContext.Provider, {
        value: patternInput[0],
    }, child_1);
}

